import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import {
	VIcon,
	VBtn,
	VImg,
	VSnackbar,
	VAutocomplete,
	VChip,
	VChipGroup,
	VContainer,
	VDialog,
	VTextField,
	VRadio,
	VRadioGroup,
	VProgressCircular,
	VAvatar,
	VCarousel,
	VCarouselItem,
	VRow,
	VCol,
} from 'vuetify/components'

// import * as components from 'vuetify/components'

import * as directives from 'vuetify/directives'

const theme = {
	defaultTheme: 'light',
	themes: {
		light: {
			colors: {
				100: '#E6E4EC',
				200: '#BCB8CA',
				300: '#968FA9',
				400: '#78708F',
				500: '#413663',
				'neutral-100': '#F9F9FB',
				'neutral-200': '#F4F4F9',
				'neutral-300': '#E5E5F8',
				'neutral-400': '#C8C8E3',
				'neutral-500': '#9D9DBB',
				'neutral-600': '#555575',
				'neutral-700': '#3A3A5F',
				'primary-100': '#F9F8FF',
				'primary-200': '#D6E0E3',
				'primary-300': '#D8D1FF',
				'primary-400': '#ACA5FF',
				'primary-500': '#1dc0b3',
				'primary-600': '#00aea0',
				'primary-700': '#693FE3',
				'success-100': '#E7FFE7',
				'success-200': '#C9FBC9',
				'success-300': '#ADF2AC',
				'success-400': '#95DB94',
				'success-500': '#7EC07D',
				'success-600': '#5BA85A',
				'success-700': '#4C964B',
				'warning-100': '#FFFBE2',
				'warning-200': '#FFF9D1',
				'warning-300': '#FFF4AB',
				'warning-400': '#FFE381',
				'warning-500': '#FACC2B',
				'warning-600': '#E8B810',
				'warning-700': '#CFA200',
				'danger-100': '#FFEBEB',
				'danger-200': '#FFD6D6',
				'danger-300': '#F8BAB9',
				'danger-400': '#F18886',
				'danger-500': '#EA6361',
				'danger-600': '#DA3F3D',
				'danger-700': '#C51311',
				// 'link-default': '#00aea0',
				// 'link-visited': '#A957EA',
				'accent-1': '#F9B146',
				'accent-2': '#32AEEE',
				'accent-3': '#BA58A1',
				darkened: 'rgba(0, 0, 0, 0.25)',

				primary: '#00aea0',
				gray900: '#000000',
				gray800: '#4C4C4C',
				// 'gray-secondary': '#00000080', rgba(var(--v-theme-gray900), .5);
				'neutral-text': '#BCB8CA',
				gray500: '#BDBDCD',
				gray400: '#D6D6E3',
				gray300: '#E7E7EF',
				gray200: '#F1F1F5',
				gray100: '#FFFFFF',
				white100: '#FFFFFF',
				'background-primary': '#FFFFFF',
				// 'background-secondary-alt': '#FFFFFF26', rgba(var(--v-theme-background-primary), .15);
				'background-secondary': '#F8F8F8',
				'purple-brand': '#00aea0',
				purple400: '#00aea080',
				purple300: '#D3C5F1',
				purple200: '#D8D1FF',
				purple100: '#F1EDFF',
				red600: '#C51311',
				red500: '#DA3F3D',
				red400: '#EA6361',
				red300: '#F18886',
				red200: '#F8BAB9',
				red100: '#FFEBEB',
				green400: '#5BA85A',
				green300: '#7EC07D',
				green200: '#95DB94',
				green100: '#C9FBC9',
				yellow400: '#DE960C',
				yellow300: '#CFA200',
				yellow200: '#E8B810',
				'yellow100-card': '#FBF8EB',
				'yellow200-card': '#FFE381',
				'yellow300-card': '#af9a4f',
				'blue100-card': '#EEF3FD',
				'blue200-card': '#B7CBF2',
				'blue300-card': '#859CC8',
				'purple100-card': '#F9F1FC',
				'purple200-card': '#E7CBF1',
				'purple300-card': '#AE83BE',
				'green100-card': '#F2F8F3',
				'green200-card': '#CBE6C5',
				'green300-card': '#93B38B',
				'gold100-card': '#FAF6F0',
				'gold200-card': '#6B5C44',
				'link-default': '#00aea0',
				'link-visited': '#A957EA',
				accent1: '#F9B146',
				accent2: '#32AEEE',
				accent3: '#BA58A1',
			},
		},
		dark: {
			colors: {
				primary: '#00aea0',
				gray900: '#FFFFFF',
				gray800: '#EBEBEB',
				// 'gray-secondary': '#FFFFFF80'
				'neutral-text': '#BCB8CA',
				gray500: '#BDBDCD',
				gray400: '#D6D6E3',
				gray300: '#E7E7EF',
				gray100: '#000000',
				white100: '#FFFFFF',
				'background-primary': '#171717',
				// 'background-secondary-alt': '#17171726',
				'background-secondary': '#23282C',
				'purple-brand': '#00aea0',
				purple400: '#00aea080',
				purple300: '#3D1F7F',
				purple200: '#D8D1FF',
				purple100: '#1E1A2D',
				red600: '#C51311',
				red500: '#DA3F3D',
				red400: '#EA6361',
				red300: '#F18886',
				red200: '#F8BAB9',
				red100: '#FFEBEB00',
				green400: '#5BA85A',
				green300: '#7EC07D',
				green200: '#95DB94',
				green100: '#C9FBC9',
				yellow400: '#DE960C',
				yellow300: '#CFA200',
				yellow200: '#E8B810',
				'yellow100-card': '#FBF8EB',
				'yellow200-card': '#FFE381',
				'yellow300-card': '#af9a4f',
				'blue100-card': '#EEF3FD',
				'blue200-card': '#B7CBF2',
				'blue300-card': '#859CC8',
				'purple100-card': '#F9F1FC',
				'purple200-card': '#E7CBF1',
				'purple300-card': '#AE83BE',
				'green100-card': '#F2F8F3',
				'green200-card': '#CBE6C5',
				'green300-card': '#93B38B',
				'gold100-card': '#FAF6F0',
				'gold200-card': '#6B5C44',
				'link-default': '#00aea0',
				'link-visited': '#A957EA',
				accent1: '#F9B146',
				accent2: '#32AEEE',
				accent3: '#BA58A1',
			},
		},
	},
}

export default createVuetify({
	// components,
	components: {
		VIcon,
		VBtn,
		VImg,
		VSnackbar,
		VAutocomplete,
		VChip,
		VChipGroup,
		VContainer,
		VDialog,
		VTextField,
		VRadio,
		VRadioGroup,
		VProgressCircular,
		VAvatar,
		VCarousel,
		VCarouselItem,
		VRow,
		VCol,
	},
	directives,
	theme,
})
